// @flow
import React from 'react';

import { TextField } from '../../../formik-utils/FormFields';
import { NATIVE_INFERENCE_POOL_DETAILS_CONFIG_MAP } from '../../../configuration/native-inference-pool-details';
import { NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME } from '../../../constants';

export const NativeInferencePoolNameContainer = ({ disabled }) => {
  const { backendFieldName, displayName, icon } = NATIVE_INFERENCE_POOL_DETAILS_CONFIG_MAP.get(
    NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME
  );
  return (
    <TextField
      disabled={disabled}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      icon={icon}
    />
  );
};
